import React, { Fragment } from 'react'
import { host } from '../../../../../../configuraciones';
import axios from 'axios'
import ModalMensajeComponent from '../../../../../App/ModalMensajeComponent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
function BotonVerOficioComponent(props) {
    //ejemplos
    const { tabla, nombreId, idSolicitud } = props
    const [openModal, setOpenModal] = React.useState(false)
    const verArchivo = async () => {
        const fileFetch = await fetch(host + `FC_01/servirOficios/tabla=${tabla}&nombreId=${nombreId}&idSolicitud=${idSolicitud}`)

        if (fileFetch.status != 404) {
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(url);
        } else {
            setOpenModal(true)
        }
    }

    return (
        <Fragment>
            <Tooltip title="Ver documento"><IconButton size="large" onClick={() => verArchivo()}> <VisibilityRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
            {
                openModal && 
                <ModalMensajeComponent setOpenModal={{setOpenModal}} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonVerOficioComponent